import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BLink } from "bootstrap-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'GridExpand',
    props: {
        detailsShowing: { type: Boolean }
    },
    emits: ["show-details"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faChevronDown, faChevronUp);
        function showDetails() {
            if (props.detailsShowing === undefined) {
                emit("show-details", true);
            }
            else {
                emit("show-details", !props.detailsShowing);
            }
        }
        return { __sfc: true, props, emit, showDetails, faChevronDown, faChevronUp, FontAwesomeIcon, BLink };
    }
});
